import Login from './login'
import Signup from './signup'
import Activate from './activate'
import Password from './password'
import NotAuthorized from './not-authorized'

/**
 * Authentication routes: logging in, signing up, activating an account,
 * setting a new password and the page shown when access is denied.
 * Shared by every applet through the Accounts applet
 */
export default [
  Login,
  Signup,
  Activate,
  Password,
  NotAuthorized
]
